import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  CircularProgress,
  Box,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

interface BulkDeleteImagesDialogProps {
  open: boolean;
  loading: boolean;
  selectedCount: number;
  onConfirm: () => void;
  onCancel: () => void;
}

export const BulkDeleteImagesDialog: React.FC<BulkDeleteImagesDialogProps> = ({
  open,
  loading,
  selectedCount,
  onConfirm,
  onCancel,
}) => {
  return (
    <Dialog
      open={open}
      onClose={!loading ? onCancel : undefined}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Toplu Resim Silme</DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Box component="span" sx={{ fontWeight: 'bold', color: 'error.main' }}>
            DİKKAT:
          </Box> Bu işlem geri alınamaz. Seçili {selectedCount} adet ürünün tüm resimleri kalıcı olarak silinecektir.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button 
          onClick={onCancel} 
          color="primary"
          disabled={loading}
        >
          İptal
        </Button>
        <Button 
          onClick={onConfirm} 
          color="error" 
          variant="contained"
          disabled={loading}
          startIcon={loading ? <CircularProgress size={24} color="inherit" /> : <DeleteIcon />}
        >
          {loading ? 'Siliniyor...' : `Evet, ${selectedCount} Ürünün Resimlerini Sil`}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

